import React, { useState } from "react";
import {
  Image,
  StyleSheet,
  View,
  ScrollView,
  Dimensions,
  StatusBar,
} from "react-native";
import * as Yup from "yup";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useHeaderHeight } from "@react-navigation/stack";

import authApi from "../api/auth";
import Screen from "../components/Screen";
import colors from "../config/colors";
import {
  AppForm,
  AppFormField,
  ErrorMessage,
  SubmitButton,
} from "../components/forms";
import AppButton from "../components/AppButton";
import routes from "../navigation/routes";
import useAuth from "../auth/useAuth";
import CommonFooter from "../components/CommonFooter";
import AppText from "../components/AppText";
import ActivityIndicator from "../components/ActivityIndicator";
import useApi from "../hooks/useApi";
import { normalize } from "../util/normalize";

const validationSchema = Yup.object().shape({
  username: Yup.string().required().email().label("Email"),
  password: Yup.string().required().min(4).label("Password"),
});

function LoginScreen({ navigation, route }) {
  const insets = useSafeAreaInsets();
  const headerHeight = useHeaderHeight();
  const [lastHeight, setLastHeight] = useState(0);
  const { logIn } = useAuth();
  // const userType = route.params;
  const [loginFailed, setLoginFailed] = useState(false);
  const loginApi = useApi(authApi.login);
  const [error, setError] = useState();

  const handleSubmit = async ({ username, password }) => {
    const result = await loginApi.request(username, password);
    console.log(result.data, "fj");

    if (result.data.response.code !== "200") {
      setError(result.data.response.message);
      return setLoginFailed(true);
    }

    setLoginFailed(false);
    const location =
      capitalizeFirstLetter(result.data.login_detail.user_city) +
      ", " +
      capitalizeFirstLetter(result.data.login_detail.user_country);

    logIn(
      result.data.login_detail.access_token,
      capitalizeFirstLetter(result.data.login_detail.user_name),
      location
    );
  };

  function capitalizeFirstLetter(string) {
    return string[0].toUpperCase() + string.slice(1);
  }

  const findPreviousDimensions = (event) => {
    const { height } = event.nativeEvent.layout;
    setLastHeight(height);
    // console.log(height, "fsl");
  };

  return (
    <Screen style={styles.container}>
      {/* <KeyboardAvoidingView
        behavior="position"
        keyboardVerticalOffset={keyboardVerticalOffset}
        style={{ flex: 1.0, flexDirection: "column" }}
      > */}

      <ScrollView
        style={{
          // flex: 1.0,
          flexDirection: "column",
          marginBottom: 60,
        }}
        keyboardShouldPersistTaps="handled"
        contentContainerStyle={{ flexGrow: 1, justifyContent: "space-between" }}
      >
        <Image
          source={require("../assets/paris_portrait.jpg")}
          style={{
            height: "100%",
            width: "100%",
            position: "absolute",
            // resizeMode: "contain",
          }}
        />
        <ActivityIndicator visible={loginApi.loading} />
        <View onLayout={findPreviousDimensions}>
          <AppForm
            initialValues={{ username: "", password: "" }}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
          >
            <View
              // onLayout={findPreviousDimensions}
              style={{
                flex: 1,
                // marginLeft: 0,
                backgroundColor: colors.skyBlueTrans,
                // minHeight:
                //   Dimensions.get('window').height -
                //   210 -
                //   insets.bottom -
                //   headerHeight,
              }}
            >
              {/* <ErrorMessage
                error="Invalid email/username or password."
                visible={loginFailed}
              /> */}
              <AppText
                color="transparent"
                style={{ alignSelf: "center", marginTop: 10 }}
                textColor={"white"}
                visible={loginFailed}
              >
                {error}
              </AppText>
              <View
                style={[
                  styles.fieldContainer,
                  {
                    marginTop: 20,
                    alignSelf: "center",
                    justifyContent: "center",
                  },
                ]}
              >
                <Image
                  source={require("../assets/human.png")}
                  style={{ width: 65, height: 65 }}
                />
                <AppText
                  style={{ marginLeft: 10 }}
                  color="transparent"
                  textColor="white"
                >
                  {"Profile Login"}
                </AppText>
              </View>
              <View
                style={[
                  styles.fieldContainer,
                  {
                    flexDirection: "column",
                    alignSelf: "center",
                  },
                ]}
              >
                {/* <AppText color="transparent" textColor="white">
                  Email{'  '}
                </AppText> */}
                <AppFormField
                  style={{
                    width: "100%",
                    alignSelf: "center",
                    marginBottom: 15,
                  }}
                  autoCapitalize="none"
                  autoCorrect={false}
                  icon="email"
                  keyboardType="email-address"
                  name="username"
                  placeholder="Email"
                  textContentType="emailAddress"
                  login={true}
                />
                <AppFormField
                  style={{
                    width: "100%",
                    alignSelf: "center",
                    marginBottom: 15,
                  }}
                  autoCapitalize="none"
                  autoCorrect={false}
                  icon="lock"
                  name="password"
                  placeholder="Password"
                  secureTextEntry
                  textContentType="password"
                  login={true}
                />
                <View
                  style={{
                    alignSelf: "center",
                    marginTop: 15,
                  }}
                >
                  <SubmitButton
                    style={{
                      paddingHorizontal: 5,
                      alignSelf: "flex-end",
                    }}
                    title="Login"
                  />
                </View>
              </View>
              <View style={[styles.fieldContainer]}>
                {/* <AppText color="transparent" textColor="white">
                  Password{'  '}
                </AppText> */}
              </View>
            </View>
          </AppForm>

          <View style={styles.lastView}>
            <AppText
              textColor="white"
              color="transparent"
              style={{
                marginTop: 20,
                marginBottom: 20,
                fontSize: normalize(19),
                fontWeight: "700",
              }}
            >
              Don't have an account?
            </AppText>
            <AppButton
              style={styles.signupButton}
              textColor="dark"
              color="yellow"
              title="Register"
              onPress={() => navigation.navigate(routes.SIGNUP_SCREEN)}
            />
            <AppButton
              style={styles.forgotButton}
              color="skyblue"
              textColor="white"
              title="Forgot Password"
              onPress={() => navigation.navigate(routes.FORGOT_SCREEN)}
            />
          </View>
        </View>
        <View
          style={{
            flex: 1,
            marginLeft: 0,
            backgroundColor: colors.primaryTrans,
            // height: lastHeight,
            minHeight: lastHeight
              ? Dimensions.get("window").height -
                lastHeight -
                insets.bottom -
                headerHeight -
                60 -
                (StatusBar.currentHeight || 0)
              : 400,
          }}
        ></View>
      </ScrollView>
      <View style={{ position: "absolute", bottom: 0 }}>
        <CommonFooter navigation={navigation} />
      </View>
      {/* </KeyboardAvoidingView> */}
    </Screen>
  );
}

const styles = StyleSheet.create({
  fieldContainer: {
    // flex: 1,
    flexDirection: "row",
    alignItems: "center",
    margin: 10,
    width: "80%",
    // height: 60,
  },
  container: {
    flex: 1,
    // padding: 10,
  },
  forgotButton: {
    // backgroundColor: "transparent",
    width: "27%",
    marginVertical: 30,
    height: 50,
    alignSelf: "center",
  },
  lastView: {
    // flex: 1,
    // flexGrow: 1,
    // justifyContent: 'flex-end',
    alignItems: "center",
    backgroundColor: colors.primaryTrans,
    // height: 150,
    // marginBottom: 60,
  },
  logo: {
    backgroundColor: colors.primary,
    alignSelf: "center",
    marginTop: 50,
    marginBottom: 20,
    borderRadius: 20,
    position: "absolute",
  },
  signupButton: {
    width: "27%",
    height: 40,
    marginBottom: 20,
    // paddingHorizontal: 20,
  },
});

export default LoginScreen;
